import { uniqueId } from "lodash";
import Quill from "quill";
import React from "react";
import ReactDOM from "react-dom";
import { variableModels, Variables } from "./Variable.type";
import { VariableComponent } from "./VariableComponent";

const Embed = Quill.import("blots/embed");

export class VariableBlot extends Embed {
    static handleDelete(id: string) {
        document.querySelector(`#${id}`)?.remove();
    }

    static create(value: any) {
        const node: any = super.create(value);

        if (typeof value === "string") {
            const model = variableModels[value as Variables];

            node.dataset.name = model.name;

            const id = uniqueId("VariableBlot");
            node.setAttribute("id", id);
            node.setAttribute("contenteditable", false);

            node.innerHTML = value;
            ReactDOM.render(
                <VariableComponent
                    title={model.title}
                    onDelete={() => {
                        VariableBlot.handleDelete(id);
                    }}
                />,
                node,
            );
        }

        return node;
    }

    static value(domNode: any) {
        return domNode.dataset.name;
    }

    appendChild(): void {
        // No implementation. To prevent error purpose.
    }
}

VariableBlot.blotName = "variable";
VariableBlot.className = "ql-variable";
VariableBlot.tagName = "SPAN";
